/**
 *  @class
 *  @function VerticalSlideshow
 *  documentation: https://gsap.com/docs/v3/Plugins/ScrollTrigger/
 */
if (!customElements.get('vertical-slideshow')) {
  class VerticalSlideshow extends HTMLElement {
    constructor() {
      super();
      let section = this;

      this.parent_section = this.closest('.shopify-section');
      this.slides = Array.from(section.querySelectorAll('.vertical-slideshow--slide'));
      this.dots = section.querySelector('.vertical-slideshow-dots');
      this.dots_li = this.dots?.querySelectorAll('li');
      this.animations = [];
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      document.addEventListener('DOMContentLoaded', this.setupScrolling.bind(this));
    }
    setupScrolling() {
      let video_containers = [];
      const length = this.slides.length;
      this.slides.forEach((slide, i) => {
        const endInfo = length - 1 === i ? "top top" : "bottom top";
        video_containers.push(slide.querySelector('.vertical-slideshow--slide-video-bg'));

        const instance = ScrollTrigger.create({
          trigger: slide,
          start: "top top",
          end: endInfo,
          pin: true,
          anticipatePin: 1,
          snap: {
            snapTo: [0, 1],
            //duration: 0.5, //reduce jump feeling
            delay: 0.2,
            inertia: false,
          },
          pinSpacing: false,
          onUpdate: self => {
            if (length - 1 !== i) {
              self.pin.style.setProperty('--snap-overlay-opacity', self.progress.toFixed(3));
              self.pin.style.setProperty('--snap-content-opacity', 1 - self.progress.toFixed(3));
            }

            /*
              [i] when onUpdate:
                scroll down [i] shows the "old" active (next active is i+1)
                scroll up [i] shows the "new" active (next active i)
              self.direction : 1 when scroll down; -1 when scroll up
              self.progress : from 0 to 1. Decimal like 0.001 .. 0.999 (goes to 16 decimals). 1.0 to 0.0 when scroll up
              !!
                When animation stops - there is light fluctoation to the sibling slide.
                In this moment "i" is different value, self.progress is something between 0 and 0.1 (scroll down) or 0.9 and 1 (scroll up).
                So we look for self.progress in the interval [0.2 .. 0.8] to exclude the jumping values.
              
              onToggle - also calls toggle dots. It is executed at animation end. Just in case to be sure it changes to the latest active slide.
            */
            if( self.direction == 1 && (self.progress > 0.2 && self.progress < 0.3)){
              /*
                scroll down - begin
                self.progress changes from [0 to 1] ; 0.2 is in the beginning; 0.8 at the end
              */
              this.setNextDot(i+1);
            }
            else if(self.direction == -1 && (self.progress > 0.7 && self.progress < 0.8)){
              /*
                scroll up - begin
                self.progress changes from [1 to 0] ; 0.8 is in the beginning; 0.2 at the end
              */
              this.setNextDot(i);
            }

            if (self.direction == -1 && self.progress < 0.3) {

              if (video_containers[i]) {
                this.videoPlay(video_containers[i]);
              }
              if (video_containers[i + 1]) {
                this.videoPause(video_containers[i + 1]);
              }
              if (video_containers[i - 1]) {
                this.videoPause(video_containers[i - 1]);
              }

            } else if (self.direction == 1 && self.progress > 0.3 && self.progress < 1) {

              if (video_containers[i]) {
                this.videoPause(video_containers[i]);
              }
              if (video_containers[i - 1]) {
                this.videoPause(video_containers[i - 1]);
              }
              if (video_containers[i + 1]) {
                this.videoPlay(video_containers[i + 1]);
              }
            }
          },
          onToggle: self => {
            if (this.dots_li) {
              if(self.direction == -1 && !self.isActive){ /*end of scroll action*/
                this.toggleDotClass(i);
              }
            }
          },
          onEnter: self => {
            /*scroll down*/
          },
          onEnterBack: self => {
            /*scroll up*/
          }
        });

      });
      window.addEventListener('scroll', () => {
        let top = this.getBoundingClientRect().top + window.scrollY;
        if (window.scrollY > top + this.offsetHeight - 100) {
          this.videoPause(video_containers[length - 1]);
        }
      }, {
        passive: true
      });
      setTimeout(() => {
        if (this.dots_li) {
          Array.from(this.dots_li).forEach((dot, index) => {
            dot.addEventListener('click', this.onDotClick.bind(this, dot, index));
          });
        }
      }, 10);
    }
    setNextDot(new_active) {
      if (this.dots_li) {
        this.toggleDotClass(new_active);
      }
    }
    toggleDotClass(i) {
      [].forEach.call(this.dots_li, function (el) {
        el.classList.remove('is-selected');
      });
      this.dots_li[i].classList.add('is-selected');
    }
    onDotClick(dot, index) {
      let spacers = this.querySelectorAll('.pin-spacer'),
        top = spacers[index].getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: top,
        left: 0,
        behavior: "smooth"
      });
    }
    videoPause(video_container) {
      if (video_container && !video_container.querySelector('video').paused) {
        video_container.querySelector('video').pause();
      }
    }
    videoPlay(video_container) {
      if (video_container.querySelector('video').paused) {
        video_container.querySelector('video').play();
      }
    }
  }
  customElements.define('vertical-slideshow', VerticalSlideshow);
}